import { render, staticRenderFns } from "./DefaultDummyContainer.vue?vue&type=template&id=6076824e&scoped=true"
import script from "./DefaultDummyContainer.vue?vue&type=script&lang=js"
export * from "./DefaultDummyContainer.vue?vue&type=script&lang=js"
import style0 from "./DefaultDummyContainer.vue?vue&type=style&index=0&id=6076824e&prod&lang=css"
import style1 from "./DefaultDummyContainer.vue?vue&type=style&index=1&id=6076824e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6076824e",
  null
  
)

export default component.exports